import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../../fonts/fonts.scss';
import * as styles from './layout.module.scss';
import '../../styles/globalStyles.scss';

const snackbarStyles = {
    success: { color: '#254c5a', backgroundColor: '#fff' },
    error: { backgroundColor: '#C5003E' }
};

interface Props {
    children: any;
}

class Layout extends React.Component<
    Props,
    {
        reminderOverlayOpen: boolean;
        navMenuOpen: boolean;
        lastMenuChange: number;
        defaultedStore: boolean;
        locale: 'en' | 'es';
        windowWidth: number;
        usingMouse: boolean;
        isMobile: boolean;
    }
> {
    constructor(props: Props) {
        super(props);
        this.state = {
            reminderOverlayOpen: false,
            navMenuOpen: false,
            lastMenuChange: 0,
            defaultedStore: false,
            locale: 'en',
            windowWidth: 0,
            usingMouse: false,
            isMobile: false
        };
    }

    async componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('keydown', this.onKeyPressEvent);
            window.addEventListener('mousedown', this.onMouseEvent);
            window.addEventListener('resize', this.handleWindowSizeChange);
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('keydown', this.onKeyPressEvent);
            window.removeEventListener('mousedown', this.onMouseEvent);
            window.removeEventListener('resize', this.handleWindowSizeChange);
        }
    }

    handleWindowSizeChange = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    onKeyPressEvent = (e: KeyboardEvent) => {
        if (
            this.state.usingMouse &&
            (e.key === 'Tab' || e.key == 'ArrowUp' || e.key == 'ArrowDown')
        ) {
            this.toggleUsingMouse(false);
        }
    };

    onMouseEvent = () => {
        if (!this.state.usingMouse) {
            this.toggleUsingMouse(true);
        }
    };

    toggleUsingMouse = (bool: boolean) => {
        this.setState({ usingMouse: bool });
    };

    closeAllMenus = () => {
        this.setState({
            navMenuOpen: false,
            reminderOverlayOpen: false
        });
    };

    toggleNavMenu = () => {
        if (this.state.navMenuOpen) {
            this.setState({
                navMenuOpen: false
            });
        } else {
            this.setState({
                navMenuOpen: true,
                reminderOverlayOpen: false
            });
        }
    };

    setNavMenu = (bool: boolean) => {
        this.setState({
            navMenuOpen: bool
        });
    };

    toggleFriendlyOverlay = () => {
        this.setState({ lastMenuChange: Date.now() });

        if (this.state.reminderOverlayOpen) {
            this.setState({
                reminderOverlayOpen: false,
                navMenuOpen: false
            });
        } else {
            this.setState({
                reminderOverlayOpen: true
            });
        }
    };

    render() {
        const childWithProps = React.cloneElement(this.props.children, {
            isMobile: this.state.isMobile,
            usingMouse: this.state.usingMouse,
            mobileMenuOpen: this.state.navMenuOpen,
            toggleMobileMenu: () => this.toggleNavMenu(),
            closeAllMenus: () => this.closeAllMenus(),
            setMobileMenu: (bool: boolean) => this.setNavMenu(bool),
            reminderOverlayOpen: this.state.reminderOverlayOpen,
            toggleFriendlyOverlay: () => this.toggleFriendlyOverlay()
        });

        return (
            <React.Fragment>
                <div className={styles.container}>
                    <div className={styles.content}>
                    <SnackbarProvider
                    maxSnack={3}
                    classes={{
                        variantSuccess: (this.props.classes as any).success
                        }}>
                        {childWithProps}
                    </SnackbarProvider>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

// export default Layout;
export default withStyles(snackbarStyles)(Layout as any);